const clientID = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
const domain = process.env.REACT_APP_AUTH0_CLIENT_DOMAIN || '';

export { clientID, domain };
